import Image from "next/image";

import ctaImg from "@/app/azerbaijan/main-page/images/azerbaijan-destination.webp";

import Button from "@/components/button/Button";
import Heading from "@/components/heading/heading";

import "@/sections/common/enquiry/enquiry.scss";
import { Link } from "react-scroll";

const Enquiry = () => {
    return (
        <div className="enquiry-block items-center px-4 grid grid-cols-1 sm:gap-4 md:grid-cols-8">
            <div className="lg:px-8 col-span-1 md:col-span-4">
                <div className="enquiry-info pt-6 pb-0 md:py-14 gap-2 flex flex-col items-start">
                    <Heading as="h2" className="text-white">
                    Don’t Miss Out Book Your Azerbaijan Trip from Kerala Today

                    </Heading>
                    {/* <p className="text-white">
                    Unlock the magic of Thailand! Enquire today and plan your dream vacation.
                    </p> */}
                    <Link to="hero">
                        <Button className="flex-center" variant="white">
                            <span>Send Enquiry</span>
                        </Button>
                    </Link>
                </div>
            </div>
            <div className="enquiry-picture col-span-1 md:col-span-4">
                <Image loading="lazy"
                    src={ctaImg}
                    alt="circle pattern"
                    className="cta-image"
                    
                />
            </div>
        </div>
    );
};

export default Enquiry;
